import { useEffect } from 'react';
import api from '../services/api';
import { markWorkspaceCdnPending } from '../lib/workspaceCdnReady';

const REFRESH_MS = 6 * 60 * 60 * 1000; // re-acquire well inside the 12h cookie TTL

/**
 * Acquire the workspace-CDN session cookie for this project (Phase B).
 *
 * The api returns the CloudFront signed-cookie triplet in the BODY; we set it
 * via document.cookie with Domain=.4klabs.ai + the project-scoped Path, which
 * the browser then sends to cdn.4klabs.ai (same-site). Failure is always
 * silent — the player falls back to /serve without it.
 */
export function useWorkspaceCdnSession(conversationId: string | undefined | null) {
  useEffect(() => {
    if (!conversationId) return;
    let cancelled = false;

    const acquire = async () => {
      try {
        const { data } = await api.get(`/conversations/${conversationId}/cdn-session`);
        if (cancelled || !data?.enabled || !data.cookies || !data.cookiePath) return;
        const expires = new Date(data.expiresAt).toUTCString();
        for (const [name, value] of Object.entries(data.cookies as Record<string, string>)) {
          document.cookie = `${name}=${value}; domain=.4klabs.ai; path=${data.cookiePath}; expires=${expires}; secure; samesite=lax`;
        }
      } catch {
        // Optional fast path only.
      }
    };

    markWorkspaceCdnPending(conversationId, acquire());
    const timer = setInterval(acquire, REFRESH_MS);
    return () => {
      cancelled = true;
      clearInterval(timer);
    };
  }, [conversationId]);
}
